<script> 
  export default {
    name: 'FormHelper'
  }
</script>

<template>
  <div class="FormHelper">
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
  .FormHelper {
    color: var(--colors-gray-500);
  }
</style>